import { render } from "./JModalPopup3DPiping.vue?vue&type=template&id=36361b12&scoped=true"
import script from "./JModalPopup3DPiping.vue?vue&type=script&lang=js"
export * from "./JModalPopup3DPiping.vue?vue&type=script&lang=js"

import "./JModalPopup3DPiping.vue?vue&type=style&index=0&id=36361b12&scoped=true&lang=scss"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36361b12"]])

export default __exports__